import { render, staticRenderFns } from "./SettingsSelect.vue?vue&type=template&id=0cbc6bf7"
import script from "./SettingsSelect.vue?vue&type=script&lang=js"
export * from "./SettingsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports